const styles = theme => ({
  title: {
    alignItems: 'center',
    display: 'flex',
    flex: 'none !important',
    position: 'relative'
  },
  iconsContainer: {
    flex: 1
  },
  titleIcon: {
    position: 'absolute',
    right: 'calc(0px - 44px)',
    padding: theme.spacing.unit * 1.25
  },
  info: {
    display: 'flex',
    marginBottom: theme.spacing.unit * 3
  },
  location: {
    flex: 1
  },
  contact: {
    flex: 1
  }
});

export default styles;
